import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";


function Footer() {
   const [visits, setVisits] = useState(0);

     const countVisit = async () => {
      try {
        const response = await axios.get(
        "https://laja.gov.pk/api/visitors.php",
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });
        console.log(response.data.visits);
        setVisits(response.data.visits);
      } catch (error) {
        console.error("Visitor counter error:", error);
      }
    };

   useEffect(() => {
    countVisit();
  }, []);

  return (
    <footer className="site-footer">
  <div className="container">
    <div className="footer-grid">
      <div>
        <h4>Find Us</h4>
         <iframe
        src="https://www.google.com/maps/embed/v1/place?q=Legal%20Aid%20and%20Justice%20Authority&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
        width="100%"
        height="320"
        title="Google Map"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade">
    </iframe>
      </div>
      <div>
        <h4>Quick Links</h4>
        <ul>
          <li><Link to="/">Home Page</Link></li>
          <li><Link to="about">About Us</Link></li>
           <li><Link to="bog">Board of Governors</Link></li>
          <li><Link to="news">News &amp; Events</Link></li>
          <li><Link to="downloads">Downloads</Link></li>
        </ul>
         <div style={{ marginTop:'15px' }}>
          <Link to="/application" className="btn btn--gold">Apply for Legal Aid</Link>
        </div>
        
      </div>
      <div>
        <h4>Resources</h4>
        <ul>
          <li><Link to="downloads" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Acts &amp; Rules</Link></li>
          <li><Link to="downloads" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Application Forms</Link></li>
          <li><Link to="downloads" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Annual Reports</Link></li>
          {/* <li><Link to="downloads" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>RTI Disclosures</Link></li> */}
          <li><Link to="downloads" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Tenders &amp; Notices</Link></li>
          <li><Link to="career">Careers</Link></li>
        </ul>
         <div style={{ marginTop:'15px' }}>
          <p className="btn" style={{backgroundColor:'#02b4f2', color:'white', borderRadius:'0px', cursor:'none'}}>Total Visits: {visits}</p>
        </div>
      </div>
      <div className="footer-contact">
        <h4>Contact Us</h4>
        <p>Helpline : <strong>051-9201790</strong></p>
        {/* <p>Fax : <strong>051-9205878</strong></p> */}
        <p>Email : contact@laja.gov.pk</p>
        <p>Address : 10th Floor, State Life Building. 5, Jinnah Avenue, Blue Area, F-6, Islamabad, 44000, Pakistan.</p>
        <div className="social-row" aria-label="Social media">
          <Link to="https://www.facebook.com/profile.php?id=61586185169804" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="currentColor" style={{color:'#fff', background:'blue'}}><path d="M14 9h3V6h-3c-1.7 0-3 1.3-3 3v2H9v3h2v7h3v-7h2.5l.5-3H14V9z"/></svg></Link>
          <Link to="https://x.com/lajapak" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" style={{color:'#fff', background:'black'}}><path d="M4 4l16 16M20 4L4 20" strokeWidth="2.6"/></svg></Link>
          <Link to="https://www.linkedin.com/company/110822913/admin/page-posts/published/" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" style={{color:'#fff', background:'#0a66c2'}}><path d="M8 10v8M8 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM12 10v8M12 13c0-2 1.2-3 3-3s3 1 3 3v5M15 10c-1.8 0-3 1-3 3" strokeWidth="2.6"/></svg></Link>
          <Link to="https://www.youtube.com/@lajapakistan/videos" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="currentColor" style={{color:'#fff', background:'red'}}><path d="M21 8s0-2-2-2H5c-2 0-2 2-2 2v8s0 2 2 2h14c2 0 2-2 2-2V8zM10 9l5 3-5 3V9z"/></svg></Link>
        </div>
        <div style={{ marginTop:'20px' }}>
          <Link to="contact" className="btn btn--gold">Contact Us</Link>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      <span>&copy; 2026 Legal Aid &amp; Justice Authority. All rights reserved.</span>
      <span>
        <Link to="">Accessibility Statement</Link>
        <Link to="">Privacy Policy</Link>
        <Link to="">Sitemap</Link>
      </span>
    </div>
  </div>
</footer>
  );
}

export default Footer;
